import CreateInventoryReceivingShipmentButtonV2 from "./CreateInventoryReceivingShipmentButtonV2";
export default CreateInventoryReceivingShipmentButtonV2;
